import {
  getBranchContractPayload,
  getBranchPayload,
  getInstitutePayload,
  getPagePayload,
  getTableGpaPayload,
  notFoundPayload,
  resolveAcademicYear,
} from "years";
import { mergeVisitorCounts } from "core/util/visitorCounts";

function parseUrl(input) {
  const clean = String(input || "").replace(/^\//, "");
  const [pathname, queryString = ""] = clean.split("?");
  return { pathname, params: new URLSearchParams(queryString) };
}

function pickYear(params) {
  return resolveAcademicYear(params.get("year"));
}

function getStaticPayload(url) {
  const { pathname, params } = parseUrl(url);
  const ceYear = pickYear(params);

  if (pathname === "page/home") return getPagePayload(ceYear, "home");
  if (pathname === "page/course") return getPagePayload(ceYear, "course");
  if (pathname === "page/enrollment") return getPagePayload(ceYear, "enrollment");
  if (pathname === "page/leave_conditions") return getPagePayload(ceYear, "leave_conditions");
  if (pathname === "page/cooperative") return getPagePayload(ceYear, "cooperative");
  if (pathname === "page/question") return getPagePayload(ceYear, "question");
  if (pathname === "page/how_to_register") return getPagePayload(ceYear, "how_to_register");
  if (pathname === "page/table_grade") return getPagePayload(ceYear, "table_grade");
  if (pathname === "page/table_retry") return getPagePayload(ceYear, "table_retry");
  if (pathname === "page/table_gpa") return getTableGpaPayload(ceYear, params.get("group"));
  if (pathname === "service") return getPagePayload(ceYear, "service");
  if (pathname === "institute") return getInstitutePayload(ceYear, params.get("course"));
  if (pathname === "institute/branch") return getBranchPayload(ceYear, params.get("branch"));
  if (pathname === "institute/branch_contract") return getBranchContractPayload(ceYear, params.get("course"));
  return notFoundPayload();
}

// Backward-compatible adapter for old components that have not yet been converted.
// New code should import content directly from `years` instead of adding new API-like calls here.
export const httpClient = {
  async get(url, options = {}) {
    const { pathname, params } = parseUrl(url);
    const staticPayload = getStaticPayload(url);
    const ceYear = pickYear(params);
    let data = staticPayload;

    if (pathname === "page/home") {
      data = await mergeVisitorCounts(staticPayload, {
        scope: "site",
        year: ceYear,
        incrementVisitor: options.incrementVisitor,
      });
    }

    if (pathname === "institute") {
      data = await mergeVisitorCounts(staticPayload, {
        scope: "institute",
        target: params.get("course"),
        year: ceYear,
        incrementVisitor: options.incrementVisitor,
      });
    }

    return { data };
  },
};
